import { STORAGE_CONSTANTS } from '../../../shared/utils/constants';
import { getLocalStorageItem, setlocalStorageItem } from '../../toolbar/CustomViewPopup/heplers/customPopupHelper';
import { ListPreference, listPreferenceKey, readListPreference, writeListPreference } from '../../../shared/components/table/listPreferences';

const getStorageKey = (isMyGroupWork?: boolean) => {
    return isMyGroupWork ? 'MY_GROUP_WORK' : 'MY_WORK_LIST';
}
// Kept per tenant, like the column widths and order below, so an agent who works in two tenants in one
// browser does not carry one tenant's tab, sort, Show Closed or last page into the other.
const tenantKey = (key: string) => `${key}:${localStorage.getItem('tid') ?? ''}`;
const storageKey = (isMyGroupWork: boolean, name: 'SHOW_CLOSED' | 'TAB' | 'LAST_PAGE_PATH') =>
    tenantKey(STORAGE_CONSTANTS[getStorageKey(isMyGroupWork)][name]);
const sortOrderKey = (isMyGroupWork: boolean, tabId: MyWorkListDataType) =>
    tenantKey(STORAGE_CONSTANTS[getStorageKey(isMyGroupWork)].SORT_ORDER[tabId]);
export const setShowClosedInStorage = (isMyGroupWork: boolean, isClosed?: boolean) => {
    setlocalStorageItem(storageKey(isMyGroupWork, 'SHOW_CLOSED'), isClosed);
};
export const getShowClosedFromStorage = (isMyGroupWork: boolean): boolean | undefined => {
    return getLocalStorageItem(storageKey(isMyGroupWork, 'SHOW_CLOSED')) || undefined;
}

export const setSelectedTabInStorage = (isMyGroupWork: boolean, tabId?: MyWorkListDataType) => {
    setlocalStorageItem(storageKey(isMyGroupWork, 'TAB'), tabId);
};
export const getSelectedTabFromStorage = (isMyGroupWork: boolean): MyWorkListDataType | undefined => {
    return getLocalStorageItem(storageKey(isMyGroupWork, 'TAB')) || undefined;
}

// Written through writeListPreference so the change is announced and Reset View lights up straight away.
export const setMyWorkSortOrderInStorage = (isMyGroupWork: boolean, tabId: MyWorkListDataType, sortOrder?: ISortOrder) => {
    writeListPreference(sortOrderKey(isMyGroupWork, tabId), sortOrder);
};
export const getMyWorkSortOrderFromStorage = (isMyGroupWork: boolean, tabId: MyWorkListDataType): ISortOrder | null => {
    return getLocalStorageItem(sortOrderKey(isMyGroupWork, tabId));
}

export const setMyWorkLastPagePathInStorage = (isMyGroupWork: boolean, path: string) => {
    setlocalStorageItem(storageKey(isMyGroupWork, 'LAST_PAGE_PATH'), path);
};
export const getMyWorkLastPagePathFromStorage = (isMyGroupWork: boolean): string | null => {
    return getLocalStorageItem(storageKey(isMyGroupWork, 'LAST_PAGE_PATH'));
}

export const myWorkColumnWidthsKey = (isMyGroupWork: boolean, tabId: MyWorkListDataType) =>
    listPreferenceKey(isMyGroupWork ? ListPreference.MyGroupWorkColumnWidths : ListPreference.MyWorkColumnWidths, localStorage.getItem('tid'), tabId);
export const myWorkColumnOrderKey = (isMyGroupWork: boolean, tabId: MyWorkListDataType) =>
    listPreferenceKey(isMyGroupWork ? ListPreference.MyGroupWorkColumnOrder : ListPreference.MyWorkColumnOrder, localStorage.getItem('tid'), tabId);

export const myWorkHiddenColumnsKey = (isMyGroupWork: boolean, tabId: MyWorkListDataType) =>
    listPreferenceKey(isMyGroupWork ? ListPreference.MyGroupWorkHiddenColumns : ListPreference.MyWorkHiddenColumns, localStorage.getItem('tid'), tabId);

const myWorkLayoutKeys = (isMyGroupWork: boolean, tabId: MyWorkListDataType) => [
    myWorkColumnWidthsKey(isMyGroupWork, tabId),
    myWorkColumnOrderKey(isMyGroupWork, tabId),
    myWorkHiddenColumnsKey(isMyGroupWork, tabId),
    sortOrderKey(isMyGroupWork, tabId),
];

export const myWorkTabHasPersonalLayout = (isMyGroupWork: boolean, tabId: MyWorkListDataType) =>
    myWorkLayoutKeys(isMyGroupWork, tabId).some(key => readListPreference(key) != null);

// Reset View: the tab goes back to its default widths, column order and sort, and removed columns come back.
export const resetMyWorkTabLayout = (isMyGroupWork: boolean, tabId: MyWorkListDataType) =>
    myWorkLayoutKeys(isMyGroupWork, tabId).forEach(key => writeListPreference(key, null));
